document.addEventListener("DOMContentLoaded", function () {
  const orderTab = document.getElementById("Order_tab");
  const referralTab = document.getElementById("Referral_tab");
  const orderBtn = document.getElementById("order_btn");
  const referralBtn = document.getElementById("Referral_btn");

  orderTab.style.display = "none";
  referralTab.style.display = "block";

  orderBtn.addEventListener("click", function (e) {
    e.preventDefault();
    orderTab.style.display = "block";
    referralTab.style.display = "none";
  });

  referralBtn.addEventListener("click", function (e) {
    e.preventDefault();
    orderTab.style.display = "none";
    referralTab.style.display = "block";
  });
});

function copyP() {
        var text =document.getElementById("copyTextP").innerText;
        var input = document.createElement('input');
        input.setAttribute('id', 'copyInput');
        input.setAttribute('value', text);
        document.getElementsByTagName('body')[0].appendChild(input);
        document.getElementById('copyInput').select();
        if (document.execCommand('copy')) {
            alert('Replication success');
        }
        document.getElementById('copyInput').remove();
    }

$(function RECURSION(){
        var numb=1
        var checkData = setInterval(function(){
            var formattedBody = "Hey, I LOVE my Tea Crystals from Pique Tea and I think you will too. They have made such a difference in my health and energy. Try them out - use my link for FREE SHIPPING on your first order (normally $7.99)! "+ $("#copyTextP").html();
          var mailToLink = "mailto:example@gmail.com?subject=This made me think of you! (try this amazing tea + get free shipping!) &body=" + formattedBody;  
           
            $(".mailMessage").attr("href",mailToLink)
            numb=numb+1
              
        },1000)
      
      }) 